module.exports = __webpack_public_path__ + "img/s2.cb4e837.png";